import React from 'react'

interface ToolbarProps {
  children: React.ReactNode
  className?: string
}

export function Toolbar({ children, className = '' }: ToolbarProps) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {children}
    </div>
  )
}

export function ToolbarGroup({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {children}
    </div>
  )
}

export function ToolbarDivider() {
  return <div className="hidden sm:block w-px h-8 bg-gray-200 dark:bg-gray-700 mx-1" aria-hidden="true" />
}
